const KEY = "hos_locks_v1";

const read = () => {
  try {
    return new Set(JSON.parse(localStorage.getItem(KEY) || "[]"));
  } catch {
    return new Set();
  }
};

export const isLocked = (k) => read().has(k);

export const lock = (k) => {
  const s = read();
  s.add(k);
  localStorage.setItem(KEY, JSON.stringify([...s]));
};
